/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getHygraphCosmosPageData } from "@cosmos/hygraph-data";
import { Locale, CosmosPageLicenseMetadataQuery } from "@cosmos/hygraph-schema";
import { getSlugParam, getHygraphLocale } from "@cosmos/next-common";
import { isError } from "@epic-mw/error-types";
import { Metadata } from "next";

import { CosmosPageMetadata } from "../common/page.types";

const getPageMetadata = async (
	locale: string = Locale.En,
	slug: string,
	previewParam?: string | string[],
	endpoint?: string,
): Promise<CosmosPageLicenseMetadataQuery> => {
	if (!slug) {
		throw new Error("Missing slug");
	}
	const preview = previewParam && typeof previewParam === "string" ? previewParam : undefined;

	const pageData = await getHygraphCosmosPageData(
		"CosmosPageLicenseMetadata",
		{
			locale: [locale, Locale.En] as Locale[],
			slug,
		},
		preview,
		endpoint,
	);

	return pageData;
};

export const getCosmosPageLicenseMetadata = async ({
	slug: rootSlug = "",
	params,
	searchParams,
	hygraphLocales,
	getAppMetadata,
	hygraphEndpoint,
}: CosmosPageMetadata): Promise<Metadata> => {
	const slugParam = getSlugParam(params);
	const slug = `${rootSlug}${slugParam}`;
	const locale = params.lang;
	let pageData: CosmosPageLicenseMetadataQuery = {};
	try {
		pageData = await getPageMetadata(
			getHygraphLocale(hygraphLocales, locale),
			slug,
			searchParams.preview,
			hygraphEndpoint,
		);
	} catch (e) {
		console.error("Failed to get metadata", { error: isError(e) && e.message });
	}
	const metaTags = pageData.cosmosPageLicense?.metaTags || {};

	return getAppMetadata(metaTags, slug, locale);
};
